import React from "react";
import { useTranslate } from "hooks/translation-hooks";
import { DetailsPanelForButtons } from "components/Cards/CardsStyled";
import { DottedButton } from "globalStyles/Containers";
import CalendarModal from "./CalendarModal";
import { useToolbar } from "components/Toolbar/hooks/useToolbar";
import { useSelector } from "react-redux";
import { showAddCalendarConfigSelector } from "redux/selectors/config";

export const AddCalendar = () => {
  const t = useTranslate();
  const { toggleMenu, displayMenu } = useToolbar("calendar-modal");
  const showAddCalendar = useSelector(showAddCalendarConfigSelector);
  return (
    <>
      {showAddCalendar && (
        <DetailsPanelForButtons>
          <DottedButton
            onClick={toggleMenu}
            data-testid="appointment-add_calendar_button"
          >
            {t("appointment-add_calendar_button")}
          </DottedButton>
          <CalendarModal showModal={displayMenu} toggleModal={toggleMenu} />
        </DetailsPanelForButtons>
      )}
    </>
  );
};

export default AddCalendar;
